enum Mutation {
  SET_IS_CHAT_OPEN = 'setIsChatOpen',
  SET_HAS_NEW_CHAT_MESSAGE = 'setHasNewChatMessage',
}

export default Mutation;
